const SLIDEMETHODS = {
  CLASS: 'CLASS',
  INDIVIDUALLY: 'INDIVIDUALLY',
  GROUP: 'GROUP',
};

export default SLIDEMETHODS;
